module.exports = __webpack_public_path__ + "img/react.259c73a6.svg";